<template>
  <div v-if="visible" class="overlay" @click="onUserClick">
    <div class="text" ref="textElement"></div>
  </div>
</template>

<script>
export default {
  name: "IntroOverlay",
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fullText: `一年来，希望镇在尼克镇长的带领下\n成为了附近人们赖以生存的庇护所\n正值希望镇一周年庆典将近\n尼克镇长正在烦恼如何搭建庆典场景…`,
      currentIndex: 0,
      isTyping: false,
      accelerated: false,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.startTyping(); // 等DOM加载完成再运行
        });
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.startTyping();
    }
  },
  methods: {
    startTyping() {
      const textElement = this.$refs.textElement;
      if (!textElement) return;
      this.currentIndex = 0;
      this.isTyping = true;
      this.accelerated = false;
      textElement.innerHTML = "";
      this.typeWriter();
    },
    typeWriter() {
      const textElement = this.$refs.textElement;
      const speed = this.accelerated ? 10 : 100;

      if (this.currentIndex < this.fullText.length) {
        const char = this.fullText[this.currentIndex];
        textElement.innerHTML += char === '\n' ? '<br/>' : char;
        this.currentIndex++;

        setTimeout(() => {
          this.typeWriter();
        }, speed);
      } else {
        this.isTyping = false;
        setTimeout(() => {
          this.$emit("finished"); // 通知父组件结束动画
        }, 2000);
      }
    },
    onUserClick() {
      if (this.isTyping && !this.accelerated) {
        this.accelerated = true;
      }
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  color: white;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transform: translateZ(100px);
}

.text {
  font-size: 26px;
  line-height: 2;
  white-space: pre-wrap;
  text-align: center;
  max-width: 80%;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/ares/anniversary/components/introOverlay.vue